import { emailTemplateApi } from "./emailTemplateApi";

const onGetTemplatePaginatedData = modal => async dispatch => {
  let data = await emailTemplateApi.getTemplatePaginatedData(modal);
  return data;
};

const onAddUpdateTemplate = modal => async dispatch => {
  let data = await emailTemplateApi.addUpdateTemple(modal);
  return data;
};

const onDeleteTemplate = tmpId => async dispatch => {
  let data = await emailTemplateApi.deleteTemplate(tmpId);
  return data;
};

const onGetTemplateById = tmpId => async dispatch => {
  let data = await emailTemplateApi.getTemplateById(tmpId);
  return data;
};

export const emailTemplateActions = {
  onGetTemplatePaginatedData: onGetTemplatePaginatedData,
  onAddUpdateTemplate: onAddUpdateTemplate,
  onDeleteTemplate: onDeleteTemplate,
  onGetTemplateById: onGetTemplateById,
};
